import { render, staticRenderFns } from "./PtControlBar.vue?vue&type=template&id=505bf37b&scoped=true"
import script from "./PtControlBar.vue?vue&type=script&lang=js"
export * from "./PtControlBar.vue?vue&type=script&lang=js"
import style0 from "./PtControlBar.vue?vue&type=style&index=0&id=505bf37b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505bf37b",
  null
  
)

export default component.exports